<template>
  <div class="home" v-if="application">
    <b-container fluid>
      <b-row>
        <b-col>
          <h1>CNA Interstate Endorsement Application Edit (Admin)</h1>
        </b-col>
      </b-row>

      <div class="card">
        <div class="card-header">Assignee</div>
        <div class="card-body">
          <b-row>
            <b-col cols="4"><BaseTextOutput label="Current Assignee" :value="application.assignedName"/></b-col>
            <b-col cols="4"><BaseTextOutput label="Assigned Date" :value="application.assignedDate"/></b-col>
<!--            <b-col cols="4" v-if="!isAssigned && !isReadonly"><b-button variant="success" class="mr-4" @click="reassign">Assign To Me</b-button></b-col>-->
          </b-row>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-button variant="primary" class="m-2" @click="convertToRenewal()">Convert to renewal</b-button>
        </b-col>
      </b-row>
      <div class="card">
        <div class="card-header">Applicant personal information</div>
        <div class="card-body">
          <b-row>
            <b-col cols="4"><BaseTextInput label="Last Name" v-model="profile.lastName" :v="$v.profile.lastName"/></b-col>
            <b-col cols="4"><BaseTextInput label="First Name" v-model="profile.firstName" :v="$v.profile.firstName"/></b-col>
            <b-col cols="4"><BaseTextInput label="Middle Name" v-model="profile.middleName" :v="$v.profile.middleName"/></b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <BaseTextInput label="Street Address" v-model="profile.contact.address.streetAddress" :v="$v.profile.contact.address.streetAddress"/>
            </b-col>
            <b-col cols="3">
              <BaseTextInput label="City" v-model="profile.contact.address.city" :v="$v.profile.contact.address.city"/>
            </b-col>
            <b-col cols="3">
              <BaseSelector label="State" v-model="profile.contact.address.state" :options="opts.stateOptions" :v="$v.profile.contact.address.state"/>
            </b-col>
            <b-col cols="3">
              <BaseMaskedTextInput label="Zip" mask="#####-####" v-model="profile.contact.address.postalCode" :v="$v.profile.contact.address.postalCode"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="3">
              <BaseMaskedTextInput label="Phone Number: " mask="(###)###-####" v-model="profile.contact.phone" :v="$v.profile.contact.phone"/>
            </b-col>
            <b-col cols="3">
              <BaseTextInput label="Email:" v-model="profile.contact.email" :v="$v.profile.contact.email"/>
            </b-col>
            <b-col cols="3">
              <BaseDateOfBirthInput label="Date of birth:" v-model="profile.dateOfBirth" :v="$v.profile.dateOfBirth"/>
            </b-col>
            <b-col cols="3">
              <BaseMaskedTextInput label="SSN:" v-model="profile.ssn" :v="$v.profile.ssn" mask="###-##-####"/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <BaseCheckboxInput id="kcEmailCheckbox" label="Attempt to change email address in keycloak?" v-model="changeKCEmail" :v="$v.changeKCEmail" tip="Ticking this box will attempt to change the email the NA uses to login. It might fail if another account exists at that email or the account that submitted this application was deleted."/>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-button variant="primary" @click="saveProfile()" class="m-2">Save personal information</b-button>
            </b-col>
          </b-row>
        </div>
      </div>
        <div class="card">
          <div class="card-header">Out of State Certification Information:</div>
          <div class="card-body">
            <b-row>
              <b-col cols="6">
                <BaseSelector label="State Certified" v-model="endorsement.state" :v="$v.endorsement.state" :options="opts.stateOptions"/>
              </b-col>
              <b-col cols="6">
                <BaseTextInput label="Certificate Number:" v-model="endorsement.certificateNumber" :v="$v.endorsement.certificateNumber"/>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="4">
                <BaseRadioInput label="Has Worked in Last 24 months?" :options="opts.yesNoBoolOptions" v-model="endorsement.workPeriod" :v="$v.endorsement.workPeriod"/>
              </b-col>
              <b-col cols="4">
                <BaseRadioInput label="Has Tested in last 24 months?" :options="opts.yesNoBoolOptions" v-model="endorsement.testPeriod" :v="$v.endorsement.testPeriod"/>
              </b-col>
              <b-col cols="4">
                <BaseDateOfBirthInput label="Test date:" v-model="endorsement.testDate" :v="$v.endorsement.testDate"/><br/>
                <b-button variant="secondary" @click="endorsement.testDate=null" class="m-2">Clear</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-button variant="primary" class="m-2" @click="saveEndorsement()">Save out of state certificate information</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="card">
          <div class="card-header">Facility information (might be blank)</div>
          <div class="card-body">
            <div v-for="(employer, index) in application.employers" v-bind:key="index">
              <h2>Facility {{index+1}} of {{application.employers.length}}:</h2>
              <b-row>
                <b-col cols="4">
                  <BaseTextInput label="Facility Name" v-model="application.employers[index].name" :v="$v.application.employers.$each[index].name"/>
                </b-col>
                <b-col cols="4">
                  <BaseRadioInput label="Staffing Agency?" :options="opts.yesNoBoolOptions" v-model="application.employers[index].staffingAgency" :v="$v.application.employers.$each[index].staffingAgency"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="3">
                  <BaseTextInput label="Street Address" v-model="application.employers[index].address.streetAddress" :v="$v.application.employers.$each[index].address.streetAddress"/>
                </b-col>
                <b-col cols="3">
                  <BaseTextInput label="City" v-model="application.employers[index].address.city" :v="$v.application.employers.$each[index].address.city"/>
                </b-col>
                <b-col cols="3">
                  <BaseSelector label="State" v-model="application.employers[index].address.state" :v="$v.application.employers.$each[index].address.state" :options="opts.stateOptions"/>
                </b-col>
                <b-col cols="3">
                  <BaseMaskedTextInput label="Zip" mask="#####-####" v-model="application.employers[index].address.postalCode" :v="$v.application.employers.$each[index].address.postalCode"/>
                </b-col>
              </b-row>
              <div v-if="application.employers[index].attachments && application.employers[index].attachments.length>0">
                <h3>Employer Attachments</h3>
                <p>This likely happened due to this application originating as a renewal</p>
                <div v-for="(attachment, index) in employer.attachments" v-bind:key="index">
                  <b-row>
                    <b-col cols="4"><BaseTextOutput label="File Name:" :value="attachment.filename"/></b-col>
                    <b-col cols="4" v-if="attachment.type"><BaseTextOutput label="Type:" :value="attachment.type.description"/></b-col>
                    <b-col cols="4" v-if="attachment.otherType"><BaseTextOutput label="Other type:" :value="attachment.otherType"/></b-col>
                  </b-row>
                  <b-row  v-if="attachment.grade">
                    <b-col cols="3">
                      <BaseTextOutput label="OCR Grade" :value="attachment.grade.description"/>
                    </b-col>
                    <b-col cols="9" v-if="attachment.concerns">
                      <BaseTextOutput label="OCR Concerns" :value="attachment.concerns"/>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-button variant="secondary" class="m-2" @click="downloadAttachment(attachment.attachmentId)">Download</b-button>
                    </b-col>
                    <b-col>
                      <b-button variant="danger" class="m-2" @click="deleteAttachment(attachment.attachmentId)">Delete</b-button>
                    </b-col>
                  </b-row>
                  <hr/>
                </div>
                <b-row>
                  <b-col>
                    <BaseCheckboxInput label="Preserve employer attachments on employer delete?" v-model="application.employers[index].preserveAttachments" :v="$v.application.employers.$each[index].preserveAttachments"/>
                  </b-col>
                </b-row>
              </div>
              <b-row>
                <b-col>
                  <b-button variant="primary" class="mt-2" @click="saveEmployer(index)">Save employer</b-button>
                </b-col>
                <b-col>
                  <b-button variant="danger" class="mt-2" @click="deleteEmployer(index)">Delete employer</b-button>
                </b-col>
              </b-row>
              <hr/>
            </div>
            <b-row>
              <b-col cols="12">
                <b-button variant="secondary" class="mt-2" @click="addEmployer()">Add employer</b-button>
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="card">
          <div class="card-header">Application attachments:</div>
          <div class="card-body">
            <div v-for="(attachment, index) in this.application.attachments" v-bind:key="index">
              <b-row>
                <b-col cols="4"><BaseTextOutput label="File Name:" :value="attachment.filename"/></b-col>
                <b-col cols="4" v-if="attachment.type"><BaseTextOutput label="Type:" :value="attachment.type.description"/></b-col>
                <b-col cols="4" v-if="attachment.otherType"><BaseTextOutput label="Other type:" :value="attachment.otherType"/></b-col>
              </b-row>
              <b-row  v-if="attachment.grade">
                <b-col cols="3">
                  <BaseTextOutput label="OCR Grade" :value="attachment.grade.description"/>
                </b-col>
                <b-col cols="9" v-if="attachment.concerns">
                  <BaseTextOutput label="OCR Concerns" :value="attachment.concerns"/>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-button variant="secondary" class="m-2" @click="downloadAttachment(attachment.attachmentId)">Download</b-button>
                </b-col>
                <b-col>
                  <b-button variant="danger" class="m-2" @click="deleteAttachment(attachment.attachmentId)">Delete</b-button>
                </b-col>
              </b-row>
            <hr/>
            </div>
            <b-row>
              <b-col>
                <FileAttachmentSupplemental v-on:attachment-added="handleUploadSuccess" v-on:attachment-failed="handleUploadFailure"
                                            :appId="application.id" :attachmentTypeOptions="attachmentTypeOptions"
                                            describedBy="intAttachmentsDesc"/>
              </b-col>
            </b-row>
          </div>
        </div>
      <div class="card-footer">
        <b-row>
          <b-col>
            <b-button variant="primary" class="m-2" :href="'/review-endorsement/'+application.id">Return to review</b-button>
          </b-col>
        </b-row>
      </div>

    </b-container>
  </div>
</template>

<script>
import BaseTextOutput from "@/components/templates/input/BaseTextOutput";
import BaseParagraphInput from "@/components/templates/input/BaseParagraphInput";
import axios from 'axios';
import {required, requiredIf, minLength, maxLength, email} from 'vuelidate/lib/validators'
import FileAttachmentSupplemental from "@/components/templates/input/FileAttachmentSupplemental";
import BaseSelector from "@/components/templates/input/BaseSelector";
import moment from 'moment';

import {commonOptions} from "@/mixins/commonOptions";
import AdminAttachmentList from "@/components/templates/AdminAttachmentList";
import BaseTextInput from "../../components/templates/input/BaseTextInput.vue";
import BaseMaskedTextInput from "../../components/templates/input/BaseMaskedTextInput.vue";
import BaseDateOfBirthInput from "../../components/templates/input/BaseDateOfBirthInput.vue";
import BaseCheckboxInput from "../../components/templates/input/BaseCheckboxInput.vue";
import BaseRadioInput from "../../components/templates/input/BaseRadioInput.vue";

export default {
  name: "EditEndorsement",
  components:{
    BaseRadioInput,
    BaseCheckboxInput,
    BaseDateOfBirthInput,
    BaseMaskedTextInput,
    BaseTextInput,
    BaseTextOutput,
    // BaseParagraphInput,
    FileAttachmentSupplemental,
    BaseSelector,
    // AdminAttachmentList
  },
  mixins: [
    commonOptions
  ],
  data:()=>({
    changeKCEmail: false,
    application: null,
    profile: null,
    certificate: null,
    endorsement: null,
    notes: [],
    notesInternal: [],
    systemNotes: [],
    noteFields: [
      {key: 'note', label: 'Note',sortable:true},
      {key: 'noteType.description',label:'Note Type', sortable:true},
      {key: 'noteDate',label:'Note Date',sortable:true},
      {key:'noteByName',sortable:true,label:'Note By'},
      {key:'noteRead.description',sortable:true,label:'Note Read?'}
    ],
    noteFieldsInternal: [
      {key: 'note', label: 'Note',sortable:true},
      {key: 'noteType.description',label:'Note Type', sortable:true},
      {key: 'noteDate',label:'Note Date',sortable:true},
      {key:'noteByName',sortable:true,label:'Note By'},
    ],
    systemNoteFields: [
      {key: 'note',label: 'Note',sortable:true},
      {key: 'noteDate', label: 'Note Date',sortable:true}
    ],
    newNote: '',
    newNoteInternal: '',
    attachmentTypeOptions: [],
    denialReasons: [],
    denialReason: null,
    otherDenialReason: '',
    processReasons: [],
    processReason: null,
    processOtherReason: null,
    newExpirationDate: null,
    substantiatedComplaints: false,
  }),
  created(){
    this.loadApplication();
    this.loadAttachmentTypes();
  },
  methods: {
    loadApplication() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/renewal/${this.$route.params.id}`)
          .then(response => {
            this.application = response.data.application;
            this.profile = response.data.profile;
            this.certificate = response.data.certificate;
            this.endorsement = response.data.endorsement;
            this.notesInternal = this.application.internal.filter(n => n.noteBy != null);
            this.notes = this.application.external;
            this.systemNotes = this.application.internal.filter(n => n.noteBy == null);
          })
    },
    loadInternalNotes() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/notesInternal/${this.$route.params.id}`)
          .then(response => {
            this.notesInternal = response.data;
          })
    },
    loadExternalNotes() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/notes/${this.$route.params.id}`)
          .then(response => {
            this.notes = response.data;
          })
    },
    loadAttachmentTypes() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/internal/mdhSupplementalTypes`)
          .then(response => {
            for (let type of response.data) {
              this.attachmentTypeOptions.push({
                value: type.code,
                text: type.description
              })
            }
          })
    },
    saveProfile() {
      this.profile.textingPreferences = null;
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/application/${this.application.id}/profile/update/${this.changeKCEmail}`, this.profile)
          .then(response => {
            if (response.data === 'kcFail') {
              this.showRootToast('Personal information change successful', 'Personal information related to this NA has been successfully changed, however there was an issue updating the keycloak account. Contact IT to have that fixed manually.', 'warning')
            } else {
              this.showRootToast('Personal information change successful', 'Personal information related to this NA has been successfully changed', 'success');
            }
            this.$nextTick(()=>{
              this.loadApplication();
            })
          })
          .catch(error => {
            if (error.response.status === 404) {
              this.showRootToast('Profile not found', 'The profile in question was not found.', 'danger');
            } else if (error.response.status === 401) {
              this.showRootToast('Unauthenticated', 'You are not logged in. Please re-login and try again.', 'danger');
            } else if (error.response.status === 403) {
              this.showRootToast('Unauthorized', 'You do not have sufficient permissions to edit this application.', 'danger');
            } else {
              this.showRootToast('Personal information change failed', `The change failed due to an unexpected error. Error code ${error.response.status}, further information: ${error.response.data}.`, 'danger');
            }
          })
    },
    saveEndorsement() {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/application/${this.application.id}/endorsement/update`, this.endorsement)
          .then(response => {
            this.showRootToast('Endorsement change successful', 'Endorsement information related to this application saved successfully', 'success');
            this.$nextTick(()=>{
              this.loadApplication();
            })
          })
          .catch(error => {
            if (error.response.status === 404) {
              this.showRootToast('Application not found', 'The application in question was not found.', 'danger');
            } else if (error.response.status === 401) {
              this.showRootToast('Unauthenticated', 'You are not logged in. Please re-login and try again.', 'danger');
            } else if (error.response.status === 403) {
              this.showRootToast('Unauthorized', 'You do not have sufficient permissions to edit this application.', 'danger');
            } else {
              this.showRootToast('Endorsement change failed', `The change failed due to an unexpected error. Error code ${error.response.status}, further information: ${error.response.data}.`, 'danger');
            }
          })
    },
    deleteEmployer(index) {
      if (this.application.employers[index].id != null) {
        axios.delete(`${process.env.VUE_APP_API_BASE_URL}/admin/application/${this.application.id}/employer/delete/${this.application.employers[index].id}/${this.application.employers[index].preserveAttachments ? 'true' : 'false'}`)
            .then(response => {
              this.showRootToast('Employer deleted', 'Employer successfully deleted', 'success');
              this.$nextTick(()=>{this.loadApplication();});

            })
            .catch(error => {
              if (error.response.status === 404) {
                this.showRootToast('Employer not found', 'The employer in question was not found (possibly deleted already?).', 'danger');
              } else if (error.response.status === 401) {
                this.showRootToast('Unauthenticated', 'You are not logged in. Please re-login and try again.', 'danger');
              } else if (error.response.status === 403) {
                this.showRootToast('Unauthorized', 'You do not have sufficient permissions to edit this application.', 'danger');
              } else {
                this.showRootToast('Employer deletion failed', `The change failed due to an unexpected error. Error code ${error.response.status}, further information: ${error.response.data}.`, 'danger');
              }
            })
      } else {
        this.$delete(this.application.employers, index);
      }
    },
    saveEmployer(index) {
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/application/${this.application.id}/employer/save`, this.application.employers[index])
          .then(response => {
            this.application.employers[index].id = response.data;
            this.showRootToast('Facility saved', 'The facility was successfully saved', 'success');
            this.$nextTick(()=>{this.loadApplication();});
          })
          .catch(error => {
            if (error.response.status === 404) {
              this.showRootToast('Not found', 'The application or employer in question was not found (possibly deleted already?).', 'danger');
            } else if (error.response.status === 401) {
              this.showRootToast('Unauthenticated', 'You are not logged in. Please re-login and try again.', 'danger');
            } else if (error.response.status === 403) {
              this.showRootToast('Unauthorized', 'You do not have sufficient permissions to edit this application.', 'danger');
            } else {
              this.showRootToast('Employer save failed', `The change failed due to an unexpected error. Error code ${error.response.status}, further information: ${error.response.data}.`, 'danger');
            }
          })

    },
    addEmployer() {
      this.application.employers.push({
        id: null,
        name: '',
        staffingAgency: false,
        address: {
          streetAddress: '',
          city: '',
          state: '',
          postalCode: ''
        }
      })
    },
    handleUploadSuccess() {
      this.showRootToast('File Attached', 'The file has been successfully attached to this application', 'success', this.$root);
      this.reloadAttachments();
    },
    handleUploadFailure() {
      this.showRootToast('Upload Failed', 'File Upload Failed', 'danger', this.$root);
    },
    formatDate(unformattedDate) {
      let formattedDate = moment(unformattedDate);
      if (!formattedDate.isValid()) return '';
      return formattedDate.format("MM/DD/YYYY")
    },
    formatDateTime(noteDateTime) {
      return moment(noteDateTime).format('MM/DD/YYYY hh:mmA');
    },
    handleDelete() {
      this.showRootToast('Deleted', 'The attachment was successfully deleted', 'success', this.$root);
      this.reloadAttachments();
    },
    showDeleteFailToast() {
      this.showRootToast('Delete failure', 'The attachment failed to delete', 'danger', this.$root);
    },
    deleteAttachment(attachmentId) {
      axios.delete(`${process.env.VUE_APP_API_BASE_URL}/attachments/delete/` + attachmentId)
          .then(response => {
            this.showRootToast('Attachment deleted', 'The attachment was successfully deleted', 'success');
            this.$nextTick(()=>{this.loadApplication();});
          })
          .catch(error => {
            if (error.response.status === 404) {
              this.showRootToast('Not found', 'The attachment in question was not found (possibly deleted already?).', 'danger');
            } else if (error.response.status === 401) {
              this.showRootToast('Unauthenticated', 'You are not logged in. Please re-login and try again.', 'danger');
            } else if (error.response.status === 403) {
              this.showRootToast('Unauthorized', 'You do not have sufficient permissions to edit this application.', 'danger');
            } else {
              this.showRootToast('Attachment deletion failed.', `The change failed due to an unexpected error. Error code ${error.response.status}, further information: ${error.response.data}.`, 'danger');
            }
          })
    },
    downloadAttachment(attachmentId){
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/attachments/getUrl/`+attachmentId)
          .then(response=>{
            if(response.data){
              window.open(response.data,"_blank");
            }
            else{
              this.showRootToast('Download failed', 'The attachment failed to download', 'danger')
            }
          })
          .catch(error=>{
            this.showRootToast('Download failed', 'The attachment failed to download', 'danger')
          })
    },
    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
        title: title,
        toaster: 'b-toaster-top-center',
        solid: true,
        variant: type,
        appendToast: true,
        noAutoHide:true
      })
      this.toastFocus()
    },
    toastFocus() {
      setTimeout(() => {
        let elem = document.getElementsByClassName("toast")
        elem = elem[elem.length-1]
        elem.focus()
      }, 100)
    },
    convertToRenewal(){
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/admin/application/${this.application.id}/convertIEToRenewal`)
          .then(response=>{
            this.showRootToast('Application converted','Application was successfully converted to renewal. Redirecting.','success');
            this.$nextTick(()=>{
              this.$router.push("/edit-renewal/"+this.application.id);
            })
          })
          .catch(error=>{
            if (error.response.status === 404) {
              this.showRootToast('Not found', 'The application was not found.', 'danger');
            } else if (error.response.status === 401) {
              this.showRootToast('Unauthenticated', 'You are not logged in. Please re-login and try again.', 'danger');
            } else if (error.response.status === 403) {
              this.showRootToast('Unauthorized', 'You do not have sufficient permissions to edit this application.', 'danger');
            } else {
              this.showRootToast('Application conversion failed.', `The change failed due to an unexpected error. Error code ${error.response.status}, further information: ${error.response.data}.`, 'danger');
            }
          })
    }
  },
  validations: {
    changeKCEmail: {required: false},
    profile:{
      lastName: {required: true},
      firstName: {required: true},
      middleName: {required: false},
      contact: {
        address: {
          streetAddress: {required: true},
          city: {required: true},
          state: {required: true},
          postalCode: {required: true, minLength: minLength(5)}
        },
        phone: {
          required: true,
          minLength: minLength(13)
        },
        email: {
          required: true,
          email
        },
      },
      dateOfBirth: {required: true},
      ssn: {required: true, minLength: minLength(11)}
    },
    endorsement:{
      certificateNumber: {required: true},
      state: {required: true},
      testDate: {required: false},
      testPeriod: {required: true},
      workPeriod: {required: true},
    },
    application:{
      employers:{
        $each:{
          name: {required: false},
          staffingAgency: {required: false},
          address:{
            streetAddress: {required: false},
            city: {required: false},
            state: {required: false},
            postalCode: {required: false}
          },
          preserveAttachments: {required: false}
        }
      }
    }
  },
  computed: {
    isReadonly() {
      return this.$keycloak.authenticated && (this.$keycloak.hasResourceRole('readonly'))
    },
    isAssigned() {
      return this.$keycloak.authenticated && this.$keycloak.subject === this.application.assigned
    },
  }

}
</script>

<style scoped>
p {
  font-weight: 700;
}

</style>